export const product01 = {
	id: "16395998003",
	title:
		"Amazon Halo View fitness tracker, with color display for at-a-glance access to heart rate, activity, and sleep tracking – Active Black – Medium/Large",
	price: 199.99,
	rating: 3,
	image: "https://m.media-amazon.com/images/I/51u6VxGdpHL._AC_SX569_.jpg",
};

export const product02 = {
	id: "16395998002",
	title:
		"KUCCU Stand Mixer, 6.5 Qt 660W, 6-Speed Tilt-Head Food Dough Mixer, Kitchen Electric Mixer with Stainless Steel Bowl,Dough Hook,Whisk, Beater, Egg white separator (6.5-QT, Black)",
	price: 239.85,
	rating: 4,
	image: "https://m.media-amazon.com/images/I/71hIoWhVckL._AC_SX679_.jpg",
};

export const product03 = {
	id: "16395998004",
	title:
		"Echo (4th Gen) | With premium sound, smart home hub, and Alexa | Charcoal",
	price: 98.99,
	rating: 4,
	image: "https://m.media-amazon.com/images/I/71JB6hM6Z6L._AC_SX679_.jpg",
};

export const product04 = {
	id: "16395998001",
	title:
		"The Lean Startup: How Today's Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses",
	price: 11.96,
	rating: 5,
	image: "https://m.media-amazon.com/images/I/51T-sMqSMiL.jpg",
};

export const product05 = {
	id: "16395998005",
	title: "2021 Apple 12.9-inch iPad Pro (Wi‑Fi, 128GB) - Space Gray",
	price: 598.99,
	rating: 5,
	image: "https://m.media-amazon.com/images/I/81+N4PFF7jS._AC_SX522_.jpg",
};

export const product06 = {
	id: "16395998006",
	title:
		"SAMSUNG 49-inch Odyssey G9 Gaming Monitor | QHD, 240hz, 1000R Curved, QLED, NVIDIA G-SYNC & FreeSync | LC49G95TSSNXZA Model",
	price: 1094.98,
	rating: 5,
	image: "https://m.media-amazon.com/images/I/61SQz8S+fEL._AC_SX679_.jpg",
};

export const product07 = {
	id: "16395998007",
	title:
		"Oculus Quest 2 — Advanced All-In-One Virtual Reality Headset — 256 GB",
	price: 399.99,
	rating: 5,
	image: "https://m.media-amazon.com/images/I/61kwRNPtMpL._SX522_.jpg",
};

export const product08 = {
	id: "16395998008",
	title:
		"Nintendo Switch w/ Neon Blue & Neon Red Joy-Con + Mario Kart 8 Deluxe (Full Game Download) + 3 Month Nintendo Switch Online Individual Membership",
	price: 389.95,
	rating: 5,
	image: "https://m.media-amazon.com/images/I/51Ue4P6FrwL._SX522_.jpg",
};

export const product09 = {
	id: "16395998009",
	title:
		"Xbox Series S - 512GB SSD Console with Wireless Controller - EU Version with US Power Cable",
	price: 359.85,
	rating: 4,
	image: "https://m.media-amazon.com/images/I/61-x29sqlpS._AC_SY450_.jpg",
};

export const product10 = {
	id: "16395998010",
	title:
		"iPhone Charger, TAKAGI Lightning Cable 3PACK 6FT Nylon Braided USB Charging Cable High Speed Data Sync",
	price: 9.99,
	rating: 4,
	image:
		"https://images-na.ssl-images-amazon.com/images/I/51jxWTdyNOL._SY445_SX342_QL70_FMwebp_.jpg",
};
